import { createContext, useContext, useState } from 'react';
import { BannerContextProviderInterface } from './types';

const BannerContext = createContext<BannerContextProviderInterface>({
  bannerHeight: 0,
  setBannerHeight: () => {},
  setCurrentBannerKey: () => {},
  currentBannerKey: undefined,
});

export const useBannerContext = () => useContext(BannerContext);

export const BannerContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [bannerHeight, setBannerHeight] = useState(0);
  const [currentBannerKey, setCurrentBannerKey] = useState<string | undefined>(undefined);

  return (
    <BannerContext.Provider
      value={{ bannerHeight, setBannerHeight, setCurrentBannerKey, currentBannerKey }}
    >
      {children}
    </BannerContext.Provider>
  );
};
